export function intersectionWithSet<T>(a: T[], b: Set<T>): T[] {
  return a.filter((x) => b.has(x));
}

export function intersection<T>(a: T[], b: T[]): T[] {
  return intersectionWithSet(a, new Set(b));
}

